import { Component, Input, OnInit } from '@angular/core';
import { AnalyticsService } from '../../../services/analytics/analytics.service';
import {  MyQuotesState } from '../definitions/my-quotes.interface';
import { MyQuotesService } from '../my-quotes.service';
import { PromoBannerData } from '../../../services/shared/shared-interface';
import { MyQuotesUtilService } from '../my-quotes.util.service';
import { SharedUtilService } from '../../../services/shared/shared-util.service';
import { LocalStorageService } from '../../../services/local-storage/local-storage.service';
import { ByParts } from '../../../services/shared/shared-enums';
@Component({
	selector: 'tmhna-portal-quote-promo-banners',
	templateUrl: './quote-promo-banners.component.html',
	styleUrls: ['./quote-promo-banners.component.scss']
})
export class QuotePromoBannersComponent implements OnInit
{
	@Input() set state(value: MyQuotesState) 
	{
		this.utilservice.updateState(value);
	}
	get state(): MyQuotesState 
	{
    	return this.utilservice.state;
	}
	constructor(private readonly analyticsService: AnalyticsService, public utilservice : MyQuotesUtilService, public service : MyQuotesService, public sharedUtilService: SharedUtilService, public localStorageService: LocalStorageService) { }
	ngOnInit(): void 
	{
		this.utilservice.getquotePromoBanner();
	}
	openLink(subscription: PromoBannerData)
	{
		this.analyticsService.trackByEvent({
			event: 'Promotional Content',
			link: {
				name: 'Learn More'
			}
		});
		if(this.sharedUtilService.isCustomerSupportSession)
		{
			if(subscription.link.label===ByParts.buyParts) 
			{
				this.sharedUtilService.navigateWithCustomerSupport(subscription.link.url);
			}
		}
		else 
		{
			window.open(subscription.link.url, '_blank');
		}
	}
}
